export default {
  methods: {
    formatCurrency(value: number) {
      return value.toLocaleString("tr-TR", {
        style: "currency",
        currency: "TRY"
      });
    }
  }
};
